import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EstimateSelector from './EstimateSelectorConnector';
import ChevronDown from '../../../themes/svg/chevronDown';
import ChevronUp from '../../../themes/svg/chevronUp';

class SelectMany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLockedExpanded: false,
    };
  }

  proceed = (e) => {
    e.preventDefault();
    this.props.advance();
  };

  toggleExpanded = () => {
    this.setState({ isLockedExpanded: !this.state.isLockedExpanded });
  }

  render() {
    return (
      <div className="selectMany">
        <span className="instructions">
          Which unshared estimate(s) from your current session would you like to share with your
          customer? Choose up to 4.
        </span>
        <div className="estimateList">
          {this.props.sharableEstimates.map(givenEst =>
            (<EstimateSelector
              designId={givenEst}
              key={`selector-${givenEst}`}
            />))}
        </div>
        {this.props.sharedEstimates.length > 0 &&
          <span
            className="heading"
            onClick={this.toggleExpanded}
            role="button"
            tabIndex="-1"
          >
            Previously Shared Estimates (no longer sharable)
            {this.state.isLockedExpanded && (
              <ChevronUp />
            )}
            {!this.state.isLockedExpanded && (
              <ChevronDown />
            )}
          </span>
        }
        {this.state.isLockedExpanded && (
          <div className="estimateList">
            {this.props.sharedEstimates.map(givenEst => <EstimateSelector designId={givenEst} key={`selector-${givenEst}`} />)}
          </div>
        )}
        <button className="btn btn-primary full-width" onClick={this.proceed} disabled={this.props.selectionCount === 0}>
          Next Step
        </button>
        <span className="counter">{this.props.selectionCount}/4 selected</span>
      </div>
    );
  }
}

SelectMany.propTypes = {
  advance: PropTypes.func.isRequired,
  sharableEstimates: PropTypes.arrayOf(PropTypes.string).isRequired,
  sharedEstimates: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectionCount: PropTypes.number.isRequired,
};

export default SelectMany;
